import { type UseQueryResult, useQuery } from 'react-query';
import { CountryService } from '../../services/wealthlane-customer-services';

const useGetCountry = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
      isOtherCountry: boolean;
    }>
  | undefined,
  unknown
> => {
  const CountryList = useQuery(
    ['getCountryList'],
    async () => {
      return await handleRequest(CountryService.getApiCustomerApiAppCountryCountries());
    },
    {
      select: (data) => {
        if (data != null) {
          data.unshift(
            data.splice(
              data.findIndex((item) => item.name === 'United States Of America'),
              1
            )[0]
          );
          return data.map((item) => {
            return {
              label: item.name ?? '',
              value: item.id ?? '',
              isOtherCountry: item.isOtherCountry ?? false,
            };
          });
        }
      },
    }
  );

  return CountryList;
};

export default useGetCountry;
